import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'appFilter' })
export class InputFilterPipe implements PipeTransform {
  /**
   * Este pipe filtra uma lista de elementos de acordo com o searchText
   *
   * @param items lista de elementos para busca
   * @param searchText texto inserido no input
   * @returns lista de elementos filtrados ou []
   */
  transform(items: string[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();

    return items.filter((item) => {
      return item.toLowerCase().startsWith(searchText);
    });
  }
}
